"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListReplicaProductPageSnapshotQuerySchema = exports.ListReplicaProductPageQuerySchema = exports.UpdateReplicaProductPagesBodySchema = exports.UpdateReplicaProductPageBodySchema = exports.ListReplicaProductPageSnapshotResponseSchema = exports.ListReplicaProductPageResponseSchema = exports.ReplicaProductPageSnapshotSchema = exports.ReplicaProductPageSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const apple_proxy_web_1 = require("../../apple-proxy-web");
exports.ReplicaProductPageSchema = (0, core_1.StrictObject)({
    teamId: core_1.IdSchema,
    adamRef: apple_proxy_web_1.AppleProxyAdamRefSchema,
    productPageRef: apple_proxy_web_1.AppleProxyCustomProductPageRefSchema,
    body: apple_proxy_web_1.AppleProxyProductPageDetailSchema,
    modifiedAt: core_1.TimestampSchema,
    duration: core_1.DurationSchema,
});
exports.ReplicaProductPageSnapshotSchema = exports.ReplicaProductPageSchema;
/**
 * Responses
 */
exports.ListReplicaProductPageResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.ReplicaProductPageSchema);
exports.ListReplicaProductPageSnapshotResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.ReplicaProductPageSnapshotSchema);
/**
 * Body
 */
exports.UpdateReplicaProductPageBodySchema = (0, core_1.StrictObject)({
    body: apple_proxy_web_1.AppleProxyProductPageDetailSchema,
});
exports.UpdateReplicaProductPagesBodySchema = (0, core_1.StrictObject)({
    modifiedAt: core_1.TimestampSchema,
    teamId: core_1.IdSchema,
    productPages: typebox_1.Type.Array(exports.UpdateReplicaProductPageBodySchema),
});
/**
 * Parameters
 */
exports.ListReplicaProductPageQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    adamRef: apple_proxy_web_1.AppleProxyAdamRefSchema,
    productPageRef: typebox_1.Type.Optional(apple_proxy_web_1.AppleProxyCustomProductPageRefSchema),
});
exports.ListReplicaProductPageSnapshotQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    ...core_1.DateFilterFields,
    adamRef: typebox_1.Type.Optional(apple_proxy_web_1.AppleProxyAdamRefSchema),
    productPageRef: typebox_1.Type.Optional(apple_proxy_web_1.AppleProxyCustomProductPageRefSchema),
});
